import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: ({ active, correct }: { active: boolean, correct: boolean }) => ({
            background: colors.color5,
            border: `1px solid ${colors.color4}`,
            padding: '8px 24px',
            ...active && ({
                background: colors.color8,
                '& .MuiTypography-root, .MuiButton-root, span': {
                    color: colors.color5,
                },
            }),
            ...correct && ({
                backgroundColor: 'c_green.main',
                '& .MuiTypography-root':{
                    color: 'white'
                },
                '& span':{
                    color: 'white'
                },
                '& .MuiButtonBase-root':{
                    color: 'white',
                }
            })
        }),
        questions: {
            display: 'flex',
            flexDirection: 'column'
        }, 
        image: {
            width: '30px',
            height: '30px',
            borderRadius: '100%'
        },
        title: {
            '& span': {
                fontWeight: '500',
            }
        },
        info: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
        },
        mainContainer: {
            display: 'flex', 
            flexDirection: 'column', 
            height: '100%', 
        },
        buttonDownload: {
            marginTop:'15px',
            marginBottom:'15px'
        }
    }
}

export { useStyles }
